<template>
    <el-dialog title="新增" v-model="editFormVisible" :close-on-click-modal="false">
        <el-form ref="form" :model="form" :rules="rules" label-width="110px">
            <el-form-item label="文档名">
                <el-input v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="备注">
                <el-input type="textarea" v-model="form.note"></el-input>
            </el-form-item>
            <el-form-item label="文档">
                <sy-doc-upload v-model="form.pic"></sy-doc-upload>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click.native="editFormVisible = false">取 消</el-button>
            <el-button v-if="authEdit" type="primary" @click="save" :loading="loading">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import util from '../../common/util'
    import mixin from '../../common/mixin'
    export default {
        mixins: [mixin],
        data() {
            return {
                authEdit:false,
                form: {},
                rules: {
                    title: [{required: true,message: '请输入文档名称', trigger: 'change'}]
                },
                loading:false,
                editFormVisible:false
            }
        },
        methods: {
            _openEdit(record,authEdit) {
                this.authEdit = authEdit
                this.editFormVisible = true;
                this.form = Object.assign({},record);
            },
            _openAdd(record) {
                this.authEdit = true
                this.editFormVisible = true;
                let form = {id:0,pic:''};
                this.form = Object.assign(form,record);
            },
            save:function () {
                let url = "server/system/DownLoad.ashx?cmd=Save"
                util.saveForm(url,this.$refs.form,this.form,this.loadFn("loading"),result=> {
                    util.msgSuc("保存成功")
                    this.editFormVisible = false
                    this.$emit("onSaveSuc",this.form)
                })
            }
        },
        created() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/system/DownLoad_Edit.vue